import { db } from "./config";
import {
  collection,
  getDocs,
  getDoc,
  doc,
  query,
  orderBy,
  limit,
  addDoc,
  updateDoc,
  deleteDoc,
  Timestamp,
} from "firebase/firestore";
import { logFirestoreOperation } from "./debugHelper";

// Get all blog posts
export const getBlogPosts = async () => {
  try {
    const blogPostsCollection = collection(db, "blogPosts");
    const q = query(blogPostsCollection, orderBy("createdAt", "desc"));
    const querySnapshot = await getDocs(q);

    return querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
      createdAt: doc.data().createdAt?.toDate(),
    }));
  } catch (error) {
    console.error("Error fetching blog posts:", error);
    return [];
  }
};

// Get a single blog post by ID
export const getBlogPost = async (postId) => {
  try {
    const docRef = doc(db, "blogPosts", postId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return {
        id: docSnap.id,
        ...docSnap.data(),
        createdAt: docSnap.data().createdAt?.toDate(),
      };
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error fetching blog post:", error);
    return null;
  }
};

// Add a new blog post
export const addBlogPost = async (postData) => {
  try {
    const blogPostsCollection = collection(db, "blogPosts");
    const newPost = {
      ...postData,
      createdAt: Timestamp.now(),
    };

    const docRef = await addDoc(blogPostsCollection, newPost);
    return docRef.id;
  } catch (error) {
    console.error("Error adding blog post:", error);
    throw error;
  }
};

// Update a blog post
export const updateBlogPost = async (postId, updatedData) => {
  if (!postId) {
    console.error("Missing postId in updateBlogPost");
    throw new Error("Post ID is required for updating a post");
  }

  try {
    console.log("Updating post with ID:", postId);
    console.log("Update data:", updatedData);

    const docRef = doc(db, "blogPosts", postId);

    // Handle timestamps correctly
    if (!updatedData.createdAt) {
      // If createdAt is not provided, don't change it
      delete updatedData.createdAt;
    } else if (!(updatedData.createdAt instanceof Timestamp)) {
      updatedData.createdAt = Timestamp.fromDate(
        new Date(updatedData.createdAt)
      );
    }

    logFirestoreOperation("updateDoc", `blogPosts/${postId}`, updatedData);

    await updateDoc(docRef, updatedData);
    return postId;
  } catch (error) {
    console.error("Error updating blog post:", error);
    throw error;
  }
};

// Delete a blog post
export const deleteBlogPost = async (postId) => {
  try {
    const docRef = doc(db, "blogPosts", postId);
    await deleteDoc(docRef);
    return true;
  } catch (error) {
    console.error("Error deleting blog post:", error);
    throw error;
  }
};
